/**
 * PrimeNG pinta los botones de solo ícono de sus diálogos (cerrar, maximizar) SIN nombre accesible: un lector de pantalla dice «botón» y nada más
 * (axe: `button-name`). Hay ~170 `<p-dialog>` en la app y el componente no toma la etiqueta de la traducción global, así que en vez de agregar
 * `closeAriaLabel` a cada plantilla se les pone aquí, una sola vez, cuando aparecen. No toca ningún botón que ya traiga su propio nombre.
 */
const ETIQUETAS: Record<string, string> = {
  pcclosebutton: 'Cerrar',
  pcmaximizebutton: 'Maximizar',
};

export function etiquetarBotonesDePrimeNg(raiz: Element): void {
  for (const [nombre, etiqueta] of Object.entries(ETIQUETAS)) {
    raiz.querySelectorAll<HTMLElement>(`button[data-pc-name="${nombre}"]:not([aria-label])`).forEach((b) => b.setAttribute('aria-label', etiqueta));
  }
}

/** Vigila el documento y etiqueta los botones que PrimeNG vaya agregando. Devuelve la función que deja de vigilar. */
export function vigilarBotonesDePrimeNg(doc: Document = document): () => void {
  etiquetarBotonesDePrimeNg(doc.body);
  const observador = new MutationObserver((cambios) => {
    for (const c of cambios) c.addedNodes.forEach((n) => { if (n instanceof Element) etiquetarBotonesDePrimeNg(n.parentElement ?? n); });
  });
  observador.observe(doc.body, { childList: true, subtree: true });
  return () => observador.disconnect();
}
